import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import '@pp/core/src/styles/core.css';

import { LauncherRoot } from './components/launcherRoot/LaucherRoot';
import './styles/launcher.css';

const root = createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <StrictMode>
    <LauncherRoot />
  </StrictMode>
);
